import { fetcher } from '@utils/fetcher';
import {
  GetInvalidPixKeyResponse,
  PlatformUser,
  ProfileExistsByDto,
  ProfileExistsByResponse,
  ResetPasswordResponse,
  UpdatePlatformUserCommissionRatesDto,
  UpdateUserDto,
  UserBalance,
  Validate2faCodeDto,
  ValidatePixKeyCredentials,
  ValidatePixKeyResponse,
  _2faStatus,
} from '@interfaces/profile';
import { ResetPasswordInput, UpdatePasswordDto } from '@interfaces/auth';
import { ResponseBoolean } from '@interfaces/api';
import { CommissionRate } from './commissionRate';
import { GenericResponse } from '@interfaces/_common';
import {
  DashboardVersion,
  UpdateDashboardVersionResponse,
} from '@interfaces/dashboardVersion';
import { DismissWelcomeDialogResponse } from '@interfaces/welcomeDialog';

const API_URL = '/api/profile';

export const getBalance = async (): Promise<UserBalance> =>
  fetcher(`${API_URL}/balance`);

export const profileExistsBy = async (
  dto: ProfileExistsByDto,
): Promise<ProfileExistsByResponse> =>
  fetcher(`${API_URL}/existsBy`, {
    method: 'POST',
    body: dto,
  });

export const getPersonalData = async (): Promise<PlatformUser> =>
  fetcher(`${API_URL}/personalData`);

export const resetPassword = async (
  dto: ResetPasswordInput,
): Promise<ResetPasswordResponse> =>
  fetcher(`${API_URL}/resetPassword`, {
    method: 'POST',
    body: dto,
  });

export const toggleAutomaticWithdral = async (): Promise<ResponseBoolean> =>
  fetcher(`${API_URL}/toggleAutomaticWithdral`, {
    method: 'PATCH',
  });

export const updatePassword = async (
  dto: UpdatePasswordDto,
): Promise<ResponseBoolean> =>
  fetcher(`${API_URL}/updatePassword`, {
    method: 'POST',
    body: dto,
  });

export const validatePixKey = async (
  dto: ValidatePixKeyCredentials,
): Promise<ValidatePixKeyResponse> =>
  fetcher(`${API_URL}/validatePixKey`, {
    method: 'POST',
    body: dto,
  });

export const updateUser = async (dto: UpdateUserDto): Promise<PlatformUser> =>
  fetcher(`${API_URL}/update`, {
    method: 'PATCH',
    body: dto,
  });

export const get2faStatus = async (): Promise<_2faStatus> =>
  fetcher(`${API_URL}/2fa/status`);

export const generate2faCode = async (): Promise<void> =>
  fetcher(`${API_URL}/2fa/generateCode`);

export const validate2faCode = async (dto: Validate2faCodeDto): Promise<void> =>
  fetcher(`${API_URL}/2fa/validateCode`, { method: 'PATCH', body: dto });

export const getPlatformUserInvalidPixKeys = async (): Promise<
  GetInvalidPixKeyResponse[]
> => fetcher(`${API_URL}/invalidPixKeys`, { method: 'GET' });

export const getPlatformUserCommissionRates = async (): Promise<
  CommissionRate[]
> => fetcher(`${API_URL}/getCommissionRates`, { method: 'GET' });

export const updatePlatformUserCommissionRates = async (
  dto: UpdatePlatformUserCommissionRatesDto,
): Promise<GenericResponse> =>
  fetcher(`${API_URL}/updateCommissionRates`, { method: 'PATCH', body: dto });

/** Rota própria, não o `update` de cadastro: aquele manda e-mail de alteração de dados e pode exigir 2FA. */
export const updateDashboardVersion = async (
  dashboardVersion: DashboardVersion,
): Promise<UpdateDashboardVersionResponse> =>
  fetcher(`${API_URL}/dashboardVersion`, {
    method: 'PATCH',
    body: { dashboardVersion },
  });

export const dismissWelcomeDialog =
  async (): Promise<DismissWelcomeDialogResponse> =>
    fetcher(`${API_URL}/welcomeDialogDismissed`, { method: 'PATCH' });
